import Checkbox from '@ixigo/iui/Checkbox';
import { InlineAlert } from '@ixigo/iui/InlineAlert';
import cn from '@repo/shared/utils/cn';
import { formatPrice } from '@repo/shared/utils/priceFormatter';
import type { ChangeEvent } from 'react';
import { useIxigoMoney } from '@/features/ixigo-money';

export interface RedeemIxigoMoneyProps {
	/** whether ixigo money redemption is selected */
	checked?: boolean;

	/** callback fired when selection toggles */
	onValueChange?: (event: ChangeEvent<HTMLInputElement>) => void;

	/** amount of ixigo money to burn in minor units (e.g., paise) or major per formatter context */
	amount: number;

	/** ISO currency code for formatting, defaults to INR */
	currency?: string;

	className?: string;
}

export const RedeemIxigoMoney = ({
	checked,
	onValueChange,
	amount: redeemAmount,
	currency = 'INR',
	className,
}: RedeemIxigoMoneyProps) => {
	const { data: wallet } = useIxigoMoney();
	const title = `Redeem ${formatPrice(redeemAmount, { currency })} ixigo money`;
	return (
		<InlineAlert
			title={title}
			{...(wallet?.balance
				? {
						description: `Available balance : ${formatPrice(wallet.balance, { currency })}`,
					}
				: {})}
			icon={
				<Checkbox
					checked={checked}
					className="m-0.5"
					onChange={onValueChange}
				/>
			}
			variant="soft"
			severity="info"
			size="lg"
			className={cn('relative items-center', className)}
		/>
	);
};

export default RedeemIxigoMoney;
